import { MDBBtn, MDBChip, MDBDatatable, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle, MDBTabs, MDBTabsContent, MDBTabsItem, MDBTabsLink, MDBTabsPane } from "mdb-react-ui-kit";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { Tooltip } from "react-tooltip";
import Body from "../../components/body/BodyPage";
import MainLinks from "../../components/navlinks/MainLinks";
import OrganizationPools from "../../components/topviews/OrganizationPools";
import Organizations from "../../components/topviews/Organizations";
function OrgGroupsLandingPage() {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const actTab1 = location.state ? location.state.tab1 ? location.state.tab1 : "tab1" : "tab1";
    const [basicActive, setBasicActive] = useState(actTab1);

    const navigate = useNavigate();

    const handleBasicClick = (value) => {
        if (value === basicActive) {
            return;
        }

        setBasicActive(value);
    };
    const actionData = {
        columns: [
            { label: 'Organization Name', field: 'name' },
            { label: 'Organization Pool(s)', field: 'orgPool' },
            { label: 'Remove', field: 'contact', sort: false },
        ],
        rows: [
            {
                name: 'Org 1',
                orgPool: (<>
                    <a href="">Default Org</a>, <a href="">Default Org</a>,
                    <a href="">Default Org</a>, <a href="">Default Org</a>,
                </>),
            },
            {
                name: 'Org 2',
                orgPool: (<>
                    <a href="">Default Org</a>, <a href="">Default Org</a>,
                    <a href="">Default Org</a>, <a href="">Default Org</a>,
                </>),
            },
            {
                name: 'Org 3',
                orgPool: (<>
                    <a href="">Default Org</a>, <a href="">Default Org</a>,
                    <a href="">Default Org</a>, <a href="">Default Org</a>,
                </>),
            },
            {
                name: 'Org 4',
                orgPool: (<>
                    <a href="">Default Org</a>, <a href="">Default Org</a>,
                    <a href="">Default Org</a>, <a href="">Default Org</a>,
                </>),
            },
            {
                name: 'Org 5',
                orgPool: (<>
                    <a href="">Default Org</a>, <a href="">Default Org</a>,
                    <a href="">Default Org</a>, <a href="">Default Org</a>,
                </>),
            },
            {
                name: 'Org 6',
                orgPool: (<>
                    <a href="">Default Org</a>, <a href="">Default Org</a>,
                    <a href="">Default Org</a>, <a href="">Default Org</a>,
                </>),
            },
            {
                name: 'Org 7',
                orgPool: (<>
                    <a href="">Default Org</a>, <a href="">Default Org</a>,
                    <a href="">Default Org</a>, <a href="">Default Org</a>,
                </>),
            },
            {
                name: 'Org 8',
                orgPool: (<>
                    <a href="">Default Org</a>, <a href="">Default Org</a>,
                    <a href="">Default Org</a>, <a href="">Default Org</a>,
                </>),
            },
        ].map((row) => {
            return {
                ...row,
                contact: (
                    <>
                        <div className="d-flex align-items-center justify-content-center">
                            <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip">
                                <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
                            </div>
                        </div>
                    </>
                ),
            };
        }),
    }
    const actionData2 = {
        columns: [
            { label: 'Pool Name', field: 'poolname' },
            { label: 'Organization Name', field: 'orgname' },
            { label: 'Remove', field: 'contact' },
        ],
        rows: [
            {
                orgname: 'Org 1',
                poolname: 'Org 1',
            },
            {
                orgname: 'Org 2',
                poolname: 'Org 2',
            },
            {
                orgname: 'Org 3',
                poolname: 'Org 3',
            },
            {
                orgname: 'Org 4',
                poolname: 'Org 4',
            },
            {
                orgname: 'Org 5',
                poolname: 'Org 5',
            },
            {
                orgname: 'Org 6',
                poolname: 'Org 6',
            },
            {
                orgname: 'Org 7',
                poolname: 'Org 7',
            },
            {
                orgname: 'Org 8',
                poolname: 'Org 8',
            },
        ].map((row) => {
            return {
                ...row,
                contact: (
                    <>
                        <div className="d-flex align-items-center justify-content-center">
                            <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip">
                                <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
                            </div>
                        </div>
                    </>
                ),
            };
        }),
    }

    // const showOrganizationInformation = () => {
    //     navigate("/orgdetails")
    // }
    const showOrgPoolInformation = () => {
        navigate("/pooledit")
    }

    const [addOrgPool, setAddOrgPool] = useState(false);

    const toggleOpenPool = () => setAddOrgPool(!addOrgPool);

    return (
        <React.Fragment>
            <>
                <MainLinks active={6} />
                <Body
                    tablinks={6}
                    sublink={282}
                    content={
                        <>
                            <section className="mb-3">
                                <div className="card card-height">
                                    <div className="card-header py-3 px-0">
                                        <h5 className="mb-0 ">
                                            Org Groups
                                        </h5>
                                    </div>
                                    <div>

                                        <MDBTabs className='mb-3'>
                                            <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleBasicClick('tab1')} active={basicActive === 'tab1'}>
                                                    Organizations
                                                </MDBTabsLink>
                                            </MDBTabsItem>
                                            <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleBasicClick('tab2')} active={basicActive === 'tab2'}>
                                                    Org Pools
                                                </MDBTabsLink>
                                            </MDBTabsItem>
                                        </MDBTabs>

                                        <MDBTabsContent>
                                            <MDBTabsPane open={basicActive === 'tab1'}>
                                                <Organizations isActive={basicActive === 'tab1'}/>
                                            </MDBTabsPane>
                                            <MDBTabsPane open={basicActive === 'tab2'}>
                                                <OrganizationPools  isActive={basicActive === 'tab2'} />
                                            </MDBTabsPane>
                                        </MDBTabsContent>

                                    </div>
                                </div>
                            </section>




                            <MDBModal open={addOrgPool} onClose={() => setAddOrgPool(false)} tabIndex='-1'>
                                <MDBModalDialog>
                                    <MDBModalContent>
                                        <MDBModalHeader>
                                            <MDBModalTitle>Add New Pool</MDBModalTitle>
                                            <MDBBtn className='btn-close' color='none' onClick={toggleOpenPool}></MDBBtn>
                                        </MDBModalHeader>
                                        <MDBModalBody>
                                            <div class="fw-500">Pool Name</div>
                                            <div className="w-100 mt-2">
                                                <MDBInput size="sm" value="Org 1" />
                                            </div>
                                            <div class="fw-500 mt-3">Organization Name</div>
                                            <div className="w-100 mt-2">
                                                <select name="" id="" className="form-select">
                                                    <option value=""></option>
                                                    <option value=""></option>
                                                    <option value=""></option>
                                                    <option value=""></option>
                                                </select>
                                            </div>
                                        </MDBModalBody>

                                        <MDBModalFooter>
                                            <MDBBtn color='secondary' onClick={toggleOpenPool}>
                                                Cancel
                                            </MDBBtn>
                                            <MDBBtn>Add</MDBBtn>
                                        </MDBModalFooter>
                                    </MDBModalContent>
                                </MDBModalDialog>
                            </MDBModal>

                        </>
                    }
                />
                <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
                    Remove
                </Tooltip>



            </>
        </React.Fragment>
    )
}
export default OrgGroupsLandingPage
